import {
  useObtenerGraficoGastosPorTipoSuplidorDashboard,
  useObtenerGraficoGastosPorTipoGastoDashboard,
  useObtenerGraficoGastosPorConceptoDashboard,
  useObtenerGraficoGastosPorFormaPagoDashboard,
  useObtenerGraficoGastosTasaGastoDashboard,
  useObtenerGraficoGastosTotalDashboard,
  useObtenerGraficoMargenNetoDashboard,
  useObtenerGraficoMargenBrutoDashboard,
  useObtenerGraficoMargenOperativoDashboard
} from "../../Scripts/Services/contabilidad-service.js";

import { SelectButton, Messages } from 'primereact';
import React, {useEffect, useState} from 'react';
import {useTheme} from "../../../Commons/Scripts/Hooks";
import { renderToStaticMarkup } from "react-dom/server";
import * as XLSX from "xlsx";
import {SvgComponent} from "../../../Commons/Scripts/Componentes";

export const GraficosContabilidad = () => {
  const color = ["#3fb1e3", "#91cc75", "#fac858", "#ee6666","#73c0de","#3ba272", "#fc8452","#9a60b4","#ea7ccc"];
    const {theme} = useTheme();
  const moneda = window.monedaPredeterminada;
  const labelOptions = {
    show: true,
    rotate: 90,
    align: "left",
    position: "insideBottom",
    verticalAlign: "middle",
    color: "#000",
    fontSize: 12,
  };
  const [where, setWhere] = React.useState({ where: { periodo: "mensual" } });
  const [value, setValue] = React.useState(3);
  const periodos = [
    { name: "Diario", value: 1 },
    { name: "Semanal", value: 2 },
    { name: "Mensual", value: 3 },
    { name: "Trimestral", value: 4 },
    { name: "Anual", value: 5 },
  ];
  const { data: gastosTotal } = useObtenerGraficoGastosTotalDashboard(where);
  const { data: gastosTasaGasto } =
    useObtenerGraficoGastosTasaGastoDashboard(where);
  const { data: gastosTipoSuplidor } =
    useObtenerGraficoGastosPorTipoSuplidorDashboard(where);
  const { data: gastosTipoGasto } =
    useObtenerGraficoGastosPorTipoGastoDashboard(where);
  const { data: gastosConcepto } =
    useObtenerGraficoGastosPorConceptoDashboard(where);
  const { data: gastosFormaPago } =
    useObtenerGraficoGastosPorFormaPagoDashboard(where);
  const {data: graficoMargenNeto} = useObtenerGraficoMargenNetoDashboard(where)
  const {data: graficoMargenBruto} = useObtenerGraficoMargenBrutoDashboard(where)
  const {data: graficoMargenOperativo} = useObtenerGraficoMargenOperativoDashboard(where)


  function m(n, d) {
    //Convertir numero => 3,000,000 a 3M
    const x = Math.floor(Math.log10(Math.abs(n)));
    const suffix = ["", "k", "M", "MM", "T", "P", "E"];
    const magnitude = Math.floor(x / 3);
    const scaled = n / Math.pow(10, magnitude * 3);
    const rounded = Math.round(scaled * Math.pow(10, d)) / Math.pow(10, d);

    return rounded + " " + suffix[magnitude];
  }
  function handleChange(value) {
    setValue(value);
    switch (value) {
      case 1:
        setWhere({ where: { periodo: "diario" } });
        break;
      case 2:
        setWhere({ where: { periodo: "semanal" } });
        break;
      case 3:
        setWhere({ where: { periodo: "mensual" } });
        break;
      case 4:
        setWhere({ where: { periodo: "trimestral" } });
        break;
      case 5:
        setWhere({ where: { periodo: "anual" } });
        break;
    }
  }
  function crearDivGrafico(data) {
    let chartTitulo = data[0]?.Desc ?? data.Titulo;
    let dom = document.getElementById("chart_" + chartTitulo);
    if (dom) {
      var chartTemp = echarts.getInstanceByDom(
        document.getElementById("chart_" + chartTitulo)
      );
      if (chartTemp) {
        chartTemp.dispose();
      }
    } else {
      let chart = document.createElement("div");
      chart.setAttribute("id", "chart_" + chartTitulo);
      chart.setAttribute("class", "chart");
      if(chartTitulo === 'Total de Gastos' || chartTitulo === 'Tasa de Gastos' || chartTitulo?.includes("Margen") ){
        document.getElementById("chart_holder_small").appendChild(chart);
      }else{
        document.getElementById("chart_holder").appendChild(chart);
       
      }
    }
  }
  function crearGraficoAgrupados(data) {
    crearDivGrafico(data);
      const svgString = renderToStaticMarkup(<SvgComponent
          iconName="export"
          fill={theme.color1}
      />);
      const svgDataUrl = `data:image/svg+xml;base64,${btoa(svgString)}`;
    var seriesData = data.Resultados.map((item) => ({
      name: item.Key,
      type: "bar",
      data: item.Datos?.map((dato) => (dato.Monto ?? 0.0)),
      emphasis: {
        focus: "series",
      },
      label: {
        ...labelOptions,
        formatter: function (params) {
          return (
            moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(params.value)
          );
        },
      },
      tooltip: {
        valueFormatter: (value) =>
          moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value),
      },
    }));
    const resultWithLongestDatos = (data.Resultados || []).reduce(function (
      maxResult,
      currentResult
    ) {
      if (
        !maxResult ||
        (currentResult.Datos?.length || 0) > (maxResult.Datos?.length || 0)
      ) {
        return currentResult;
      } else {
        return maxResult;
      }
    },
    null);
    const longestDatosArray = resultWithLongestDatos?.Datos;
    var chartDom = document.getElementById("chart_" + data.Titulo);
    const chart = echarts.init(chartDom, null, {
      width: "1350",
      height: "350",
    });
    var options = {
      color: color,
      title: {
        text: data.Titulo,
        left: "center",
        textStyle: {
          fontStyle: "normal",
          fontWeight: "bolder",
          fontFamily: "sans-serif",
        },
      },
        toolbox: {
            show: true,
            feature: {
                myTool1: {
                    show: true,
                    title: 'exportar',
                    icon: `image://${svgDataUrl}`,
                    onclick: function (){
                        const option = chart.getOption();
                        const source = option.dataset[0].source;
                        const dimensions = option.dataset[0].dimensions;
    
                        const rows = [dimensions, ...source.map(obj => dimensions.map(dim => obj[dim]))];
    
                        const ws = XLSX.utils.aoa_to_sheet(rows);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    
                        XLSX.writeFile(wb, `${data.Titulo || "chart-data"}.xlsx`);
                    }
                }
            }
        },
      legend: {
        top: "bottom",
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      dataset: {
        dimensions: ["periodo", "Total"],
        source: data.Resultados.map((d) => {
          return {
            periodo: d.FechaDesc,
            Total: d.Datos?.map((e) => (e.Monto ?? 0.0)),
          };
        }),
      },
      xAxis: {
        type: "category",
        data: longestDatosArray?.map(function (item) {
          return item.FechaDesc;
        }),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          fontSize: 9,
          formatter: function (params) {
            if (params >= 1000) return `${moneda} ${m(params, 1)}`;
            else
              return `${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(params)}`;
          },
        },
      },
      series: seriesData,
    };
    chart.setOption(options);
  }
  function crearGrafico(data){ 
    crearDivGrafico(data);
      const svgString = renderToStaticMarkup(<SvgComponent
          iconName="export"
          fill={theme.color1}
      />);
      const svgDataUrl = `data:image/svg+xml;base64,${btoa(svgString)}`;
    var chartDom = document.getElementById('chart_' + data?.Titulo);
    const chart = echarts.init(chartDom,null,{width: '653', height: '300'} );
    var options = {
        color: color,
        title: {
            text: data.Titulo,
            left: 'center',
            textStyle: {
                fontStyle: 'normal',
                fontWeight: 'bolder',
                fontFamily: 'sans-serif'
            }
        },
        legend: {
            orient: 'horizontal',
            left: 'center',
            top: 'bottom',
            show: false
        },
        toolbox: {
            show: true,
            feature: {
                myTool1: {
                    show: true,
                    title: 'exportar',
                    icon: `image://${svgDataUrl}`,
                    onclick: function (){
                        const option = chart.getOption();
                        const source = option.dataset[0].source;
                        const dimensions = option.dataset[0].dimensions;

                        const rows = [dimensions, ...source.map(obj => dimensions.map(dim => obj[dim]))];

                        const ws = XLSX.utils.aoa_to_sheet(rows);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

                        XLSX.writeFile(wb, `${data.Titulo || "chart-data"}.xlsx`);
                    }
                }
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
        },
        dataset: {
            dimensions: ['periodo', 'Total'],
            source: data.Resultados.map((d) => {
                return {
                    periodo: d.FechaDesc,
                    Total: d.Monto,
                }
            })
        },
        xAxis: { type: 'category', },
        yAxis: {
            type: 'value',
            axisLabel: {
                fontSize: 9,
                formatter: function (params) {
                    if(data.Titulo?.includes("Tasa") || data.Titulo?.includes("Margen")){
                        return `${params} %`
                    }else {
                        if(params >= 1000) return `${moneda} ${m(params,1)}`
                        else return `${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(params)}`  
                    }                    
                }
            },
        },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series:
            [
                {
                    type: 'bar',
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        ...labelOptions,
                        formatter: function (params) {
                            if(data.Titulo.includes("Tasa") || data.Titulo.includes("Margen")){
                                return params.value.Total.toFixed(2) + "%";
                            }else {
                                return moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(params.value.Total)
                            }
                        },
                    },
                    tooltip: {
                        valueFormatter: value => data.Titulo?.includes("Tasa") || data.Titulo?.includes("Margen")?  value.toFixed(2) + "%" : moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value) 
                    }
                },
            ]
    };
    chart.setOption(options);
}
  React.useEffect(() => {
    if (gastosTotal) {
      crearGrafico(gastosTotal);
    }
  }, [gastosTotal]);
  React.useEffect(() => {
    if (gastosTasaGasto) {
      crearGrafico(gastosTasaGasto);
    }
  }, [gastosTasaGasto]);
  React.useEffect(() => {
    if (gastosTipoSuplidor) {
      crearGraficoAgrupados(gastosTipoSuplidor);
    }
  }, [gastosTipoSuplidor]);
  React.useEffect(() => {
    if (gastosTipoGasto) {
      crearGraficoAgrupados(gastosTipoGasto);
    }
  }, [gastosTipoGasto]);
  React.useEffect(() => {
    if (gastosConcepto) {
      crearGraficoAgrupados(gastosConcepto);
    }
  }, [gastosConcepto]);
  React.useEffect(() => {
    if (gastosFormaPago) {
      crearGraficoAgrupados(gastosFormaPago);
    }
  }, [gastosFormaPago]);
  React.useEffect(() => {
    if (graficoMargenNeto) {
      crearGrafico(graficoMargenNeto);
    }
  }, [graficoMargenNeto]);
  React.useEffect(() => {
    if (graficoMargenBruto) {
      crearGrafico(graficoMargenBruto);
    }
  }, [graficoMargenBruto]);
  React.useEffect(() => {
    if (graficoMargenOperativo) {
      crearGrafico(graficoMargenOperativo);
    }
  }, [graficoMargenOperativo]);

  return (
    <div>
      <SelectButton
        value={value}
        onChange={(e) => handleChange(e.value)}
        optionLabel="name"
        options={periodos}
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "10px",
          padding: "12px",
          flexFlow: "columnWrap",
          aligItems: "center",
        }}
      />
      <div id="chart_holder_small" class="card_row"></div>
      <div id="chart_holder" class="card_row"></div>
    </div>
  );
};
